import { useHistory, useLocation } from "react-router-dom";
import {
  setActiveAccount,
} from "api";
import { useEffect } from "react";

const useSwitchWorkspace = (active_account, accounts, setBrandDetails) => {
  const router = useHistory();
  const { pathname, search } = useLocation();

  const getSavedAccountId = async() => {
    const account_id = localStorage.getItem("account_id");
    const account1 = accounts[0];
    const tempAccount = accounts?.find(
      (item) => item?.id === parseInt(account_id)
    );

    if (tempAccount) {
      setActiveAccount(tempAccount);
    } else {
      setActiveAccount(account1);
    }
    // getBrands()

    savePathName();
  };

  const savePathName = () => {
    if (!active_account?.id) return;
    localStorage.setItem(
      `savedPathName_${active_account?.id}`,
      `${pathname}${search}`
    );
  };

  const saveAccountId = (account) => {
    if (!account.id || account.id === active_account?.id) return;

    setBrandDetails(null);

    localStorage.setItem("account_id", account.id);

    const savedPathName = localStorage.getItem(`savedPathName_${account.id}`);

    router.push(savedPathName || "/dashboard/posts");

    getSavedAccountId();
  };

  useEffect(() => {
    getSavedAccountId();
    // eslint-disable-next-line
  }, [accounts]);

  useEffect(() => {
    savePathName();
    // eslint-disable-next-line
  }, [accounts]);

  return {saveAccountId}
}

export default useSwitchWorkspace;